// colors.ts
export const COLORS = {
  Page: '#F6F8FA',
  Border: '#DBDBDB',
  FieldsBg: '#FFFFFF',
  TableHeadBG: '#ECEFF3',
  TableHead: '#5C6578',
  Select: '#66AAFF',
  Main: '#66AAFF',
  Secondary: '#BEBEC3',
  Success: '#138C1F',
  Scheduled: '#EE9D00',
  Error: '#ff0000',
  Off: '#DC1B1B',
}
